import React from "react";
// COMPONENTS
import { revealProps } from "Components/WebsiteTheme/Reveal";
import { SITE_SUBJECTS } from "Components/WebsiteTheme/site.data";
import useOpenSubject from "Components/WebsiteTheme/useOpenSubject";
// STYLES
import { AboutSubjectsSection } from "./AboutUs.style";

/** One Platform. Seven Subjects.: same subjects and order as Home, as photo tiles. */
const OurSubjects = () => {
	const openSubject = useOpenSubject();

	return (
		<AboutSubjectsSection className="sm_section sm_section--tint">
			<div className="sm_container">
				<div className="as_head" {...revealProps("up")}>
					<h2 className="sm_title">
						One Platform. Seven Subjects.
						<br />
						<span className="sm_accent">A School-Wide Solution.</span>
					</h2>
					<p className="sm_lead">
						Subjects Master gives schools one platform that supports educators across multiple departments, rather than limiting interactive learning to a single subject area.
					</p>
				</div>

				<ul className="as_grid">
					{SITE_SUBJECTS.map((subject, index) => {
						return (
							<li key={subject.id} className={index === SITE_SUBJECTS.length - 1 ? "as_cell--wide" : undefined} {...revealProps("up", index)}>
								<button type="button" className="as_tile" style={{ "--tone": subject.tone }} onClick={() => openSubject(subject.id)} aria-label={`Explore ${subject.title}`}>
									<img src={subject.image} alt="" width="640" height="626" loading="lazy" />
									<span className="as_label">{subject.title}</span>
								</button>
							</li>
						);
					})}
				</ul>
			</div>
		</AboutSubjectsSection>
	);
};

export default OurSubjects;
